module.exports = __webpack_public_path__ + "static/img/7.c94cae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/detect/7.png
// module id = jGEJ
// module chunks = 13